import Register from './Register';

export default Register;


// WEBPACK FOOTER //
// ./src/components/pages/Register/index.js